import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {newsletterMailList_template} from "../components/templates/newsletterMailList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class newsletter_mails extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected newsletterMailList: newsletterMailList_template;
    protected pagination: pagination_template;

    buildContent(): Element[] {
        this.newsletterMailList = new newsletterMailList_template("newsletterMailList", this.viewModel, this)
        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        (loadedModule as header).setHeaderTitle("Newsletter Mail List");
        return [this.newsletterMailList.build()];
    }

    protected getModuleName(): string {
        return "newsletter_mails";
    }

    fillPage() {

        this.getNewsletterReferences();
    }

    protected filterList() {
        this.loadingIn(this.newsletterMailList.builtTemplate.children.namedItem("list-results"));
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        const params: string[][] = [];
        params.push(["data", ko.toJSON(this.newsletterMailList.getViewModelForRequest())]);

        const url: string = '/api/brand/' + idBrand + "/newsletter/emails/get/";

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetNewsletterMailDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetNewsletterMailDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                const responseParsed = JSON.parse(req.request.response);

                const totalCount = responseParsed.totalCount
                const totalPage = responseParsed.totalPage
                const newsletterMails = responseParsed.data;

                obj.viewModel.newsletterMailList.pagination.itemCount(totalCount);

                const execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100

                obj.newsletterMailList.setResultInfo(totalCount, totalPage, execTime)

                obj.newsletterMailList.setNewsletterMails(newsletterMails, obj.getBrandId())

            });
            obj.loadingOut(obj.newsletterMailList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected getNewsletterReferences() {

        // LOADING : starts
        this.loadingIn(this.newsletterMailList.builtTemplate);

        const usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/references';
        const usrReq_params: string[][] = [['references', 'permissions']];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onNewsletterRequestReturn;
        this.XHRHdl.execute();
    }

    public onNewsletterRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.newsletterMailList.builtTemplate);

                // check if user has article write permissions
                const responseParsed = JSON.parse(req.request.response);

                obj.newsletterMailList.setPermissions(responseParsed.permissions)

                    obj.filterList();
            })
        }
    }

    protected newsletterMailListReorder() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.filterList()
    }

    protected paginationOnPageClick() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.filterList();
    }

    protected viewNewsletterMail(id) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/emails/view/' + id + '/')
    }

    protected addNewsletterMail() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/emails/add/')
    }

    protected deleteNewsletterMail(data) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        const idBrand = this.getVnAppZone().getApp().params.idBrand;

        const formReq_url = "/api/brand/" + idBrand + "/newsletter/emails/delete/" + data.id + "/"
        const formReq_params: string[][] = [];

        this.loadingIn(this.newsletterMailList.builtTemplate.children.namedItem("list-results"));
        const XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    const responseParsed = JSON.parse(req.request.response);
                    console.log(responseParsed)

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "Newsletter " + "<strong>" + responseParsed.subject + "</strong>" + "was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule()
                    obj.filterList()
                })

                obj.loadingOut(obj.newsletterMailList.builtTemplate.children.namedItem("list-results"));

            }
        });
        XHRHdl.execute();
    }

    protected filterSimpleOnChange(idElement){

        this.viewModel.newsletterMailList.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

}


// WEBPACK FOOTER //
// ./js/modules/newsletter_mails.ts